import { useInfiniteQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'react-router-dom';

import { getNextPageParam } from '@pkg/hooks';

import { ItemType } from '@app/client/common/structs/wishlists/wishlists';
import { callGetWishlistItems, WISHLIST_ITEMS_CACHE } from '@app/client/resources/wishlists';
import { PathParams } from '@app/routes/types';

import { WishlistTabs } from '../../components/Header/NavigationBar';

const DEFAULT_WISHLIST_ITEMS_LIMIT = 20;
export const useGetWishlistItems = (slug?: string, disabled?: boolean) => {
    const limit = DEFAULT_WISHLIST_ITEMS_LIMIT;
    const { [PathParams.WishlistSlug]: wishlistSlug } = useParams();
    const listSlug = slug || wishlistSlug;

    const [searchParams] = useSearchParams();
    const currentTab = searchParams.get('tab');

    let type: ItemType = ItemType.Collection;

    if (currentTab === WishlistTabs.Collectibles) type = ItemType.Token;

    const cache = [WISHLIST_ITEMS_CACHE, listSlug, type, limit];

    return useInfiniteQuery(
        cache,
        ({ pageParam = 0, signal }) =>
            callGetWishlistItems({
                wishlist_id: listSlug || '',
                type,
                query: { page: pageParam || 0, limit },
                settings: { signal },
            }),
        {
            retry: false,
            keepPreviousData: true,
            getNextPageParam,
            enabled: Boolean(listSlug) && !disabled,
        },
    );
};
